import Vue from 'vue';
import BladeSpinner from '../components/BladeSpinner';

export const unused = items => ({
  by: itemField => ({
    in: selectedItems => ({
      by: selectedItemField => ({
        at: index => (
          items.filter((item) => {
            const itemValue = itemField ? item[itemField] : item;
            return !selectedItems.some((selectedItem, i) => {
              const selectedItemValue =
                selectedItemField ? selectedItem[selectedItemField] : selectedItem;
              return itemValue === selectedItemValue && index !== i;
            });
          })
        )
      })
    })
  })
});

export const test = () => false;

const BladeSpinnerClass = Vue.extend(BladeSpinner);

export const handleIFrame = (frameOrId, newsrc = '', data = null) => {
  let frame = frameOrId;
  if (typeof frameOrId === 'string') {
    frame = document.getElementById(frameOrId);
  }
  if (frame) {
    let spinnerElement;

    if (frame.id) {
      spinnerElement = document.getElementById(`${frame.id}-spinner`);
    }

    if (spinnerElement) {
      spinnerElement.style.display = 'block';
      spinnerElement.style.top = `${frame.clientHeight / 2}px`;
    } else {
      const spinner = new BladeSpinnerClass({
        propsData: { nested: true, noBackground: true }
      });
      spinner.$mount();
      spinner.$el.style.margin = 'auto';
      spinner.$el.style.position = 'relative';
      spinner.$el.style.top = `${frame.clientHeight / 2}px`;
      spinnerElement = spinner.$el;
      if (frame.id) spinnerElement.id = `${frame.id}-spinner`;
      if (frame.style.display === 'none') spinnerElement.style.display = 'none';
      const spinnerParent = document.createElement('div');
      spinnerParent.style.width = frame.style.width;
      spinnerParent.style.height = 0;
      spinnerParent.style.overflow = 'visible';
      frame.style.position = 'relative';
      if (!(frame.style.backgroundColor)) {
        frame.style.backgroundColor = 'transparent';
      }
      spinnerParent.appendChild(spinner.$el);
      frame.parentElement.insertBefore(spinnerParent, frame);
    }

    if (newsrc) {
      frame.src = '';
      frame.onload = () => {
        if (frame.style.display === 'none') spinnerElement.style.display = 'none';
        frame.style.display = 'block';
        setTimeout(() => {
          spinnerElement.style.display = 'block';
          spinnerElement.style.top = `${frame.clientHeight / 2}px`;
        }, 20);
        frame.src = newsrc;
        if (frame.src.startsWith(window.origin) || !(frame.src.startsWith('http'))) {
          setTimeout(() => {
            spinnerElement.style.display = 'none'; // already done loading
          }, 1333);
        } else {
          frame.onload = () => {
            spinnerElement.style.display = 'none';
          };
        }
      };
    } else if (
      frame.contentDocument == null // if cross-origin content, the document becomes null
      || (frame.contentDocument.childElementCount > 1 && frame.contentDocument.firstElementChild.childElementCount > 0)
    ) {
      spinnerElement.style.display = 'none'; // already done loading
    } else if (frame.src.startsWith(window.origin) || !(frame.src.startsWith('http'))) {
      if (data) data.framesToLoad += 1;
      setTimeout(() => {
        spinnerElement.style.display = 'none'; // already done loading
        if (data) data.framesToLoad = Math.max(0, data.framesToLoad - 1);
      }, 1333);
    } else {
      if (data) data.framesToLoad += 1;
      frame.onload = () => {
        spinnerElement.style.display = 'none';
        if (data) data.framesToLoad = Math.max(0, data.framesToLoad - 1);
      };
    }
  }
};

/**
 * In general, you should pass in `this`
 * and this function expects a `data` member called `framesToLoad`,
 * which it will increment and decrement as appropriate
 * and the calling component can block progress as desired in response.
 * If framesToLoad is not needed information you can skip passing in anything.
 */
export const handleIFrames = (data) => {
  const iframes = document.getElementsByTagName('iframe');
  // console.log(iframes);
  // eslint-disable-next-line no-restricted-syntax
  for (const frame of iframes) { // frame is HTMLIFrameElement
    handleIFrame(frame, '', data);
  }
};



// WEBPACK FOOTER //
// ./src/utils/utils.js